import { Project } from '../types/project';

export const projects: Project[] = [
  {
    id: 4,
    title: 'This Civilisational Moment',
    category: 'writing',
    externalUrl: 'https://llewellynsub.substack.com/p/this-civilisational-moment',
    imageUrl: '/images/this moment.webp',
  },
  {
    id: 1,
    title: 'NEM Map',
    category: 'energy',
    externalUrl: 'https://nem-map.pages.dev/',
    imageUrl: '/images/nem-map.png',
  },
  {
    id: 5,
    title: 'Battery Now vs V2G',
    category: 'energy',
    externalUrl: 'https://battery-or-v2g.pages.dev/',
    imageUrl: '/images/battery-or-v2g.png',
  },
  {
    id: 2,
    title: 'WorldView',
    category: 'thinking',
    externalUrl: 'https://worldview1.pages.dev/',
    imageUrl: '/images/worldview.png',
  },
  {
    id: 3,
    title: 'DreamCatcher',
    category: 'thinking',
    externalUrl: 'https://dreamcatcher-io.replit.app/',
    imageUrl: '/images/dreamcatcher.png',
  },
]; 
